import { render, staticRenderFns } from "./MteTypeList.vue?vue&type=template&id=1f0bc876&scoped=true"
import script from "./MteTypeList.vue?vue&type=script&lang=js"
export * from "./MteTypeList.vue?vue&type=script&lang=js"
import style0 from "./MteTypeList.vue?vue&type=style&index=0&id=1f0bc876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0bc876",
  null
  
)

export default component.exports